import { createSlice } from "@reduxjs/toolkit";
import { loginUserSelectInstitution, logoutUser } from "../actions/account";

const initialState = {
  tableFilters: {},
  columnFilters: [],
  selectedAllProfiles: false,
  selectedProfileIds: [],
  unselectedProfileIds: [],
};

const profileUISlice = createSlice({
  name: "profileUI",
  initialState,
  reducers: {
    storeProfileFilters(state, action) {
      state.tableFilters = action.payload;
    },
    storeProfileColumnFilters(state, action) {
      state.columnFilters = action.payload;
    },
    setSelectedAllProfiles(state, action) {
      state.selectedAllProfiles = action.payload
    },
    setSelectedProfileIds(state, action) {
      state.selectedProfileIds = action.payload
    },
    setUnselectedProfileIds(state, action) {
      state.unselectedProfileIds = action.payload
    },
  },
  extraReducers: {
    [logoutUser.fulfilled]: (state) => {
      return initialState;
    },
    [logoutUser.rejected]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.fulfilled]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.rejected]: (state) => {
      return initialState;
    },
  },
});

export const getTableFilters = (state) => state.profileUI.tableFilters;
export const getColumnFilters = (state) => state.profileUI.columnFilters;
export const getSelectedAllProfiles = (state) => state.profileUI.selectedAllProfiles;
export const getSelectedProfileIds = (state) => state.profileUI.selectedProfileIds;
export const getUnselectedProfileIds = (state) => state.profileUI.unselectedProfileIds;

export const { storeProfileFilters, storeProfileColumnFilters, setSelectedAllProfiles, setSelectedProfileIds, setUnselectedProfileIds } = profileUISlice.actions;

export default profileUISlice;
